import React from 'react';
import {
    ComponentsProps,
    ComponentsOverrides,
    ComponentsVariants,
    formLabelClasses,
    Theme,
    Box,
    FormHelperTextProps,
} from '@mui/material';
import { CloseIcon } from '../../../components';

const ErrorIconClass = 'Mui-error-icon';
const TextClass = 'CaroteneFormHelperText-text';

export const MuiFormHelperText: {
    defaultProps?: ComponentsProps['MuiFormHelperText'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiFormHelperText'];
    variants?: ComponentsVariants['MuiFormHelperText'];
} = {
    defaultProps: {
        component: ({ children, ...otherProps }: FormHelperTextProps<typeof Box>) => {
            const TextComponent = typeof children === 'string' ? 'p' : 'div';
            return (
                <Box
                    display="flex"
                    alignItems="center"
                    flexDirection="row"
                    gap={(theme) => theme.spacing(theme.tokens.spacing.xxs)}
                    {...otherProps}
                >
                    <CloseIcon className={ErrorIconClass} />
                    <TextComponent className={TextClass}>{children}</TextComponent>
                </Box>
            );
        },
    },
    styleOverrides: {
        root: (props) => [
            props.theme.typography.helperText,
            {
                textAlign: 'start',
                marginInlineStart: 0,
                marginInlineEnd: 0,
                marginBlockStart: props.theme.spacing(props.theme.tokens.spacing.xxs),
                [`& > .${TextClass}`]: {
                    marginBlockStart: 0,
                    marginBlockEnd: 0,
                    inlineSize: '100%',
                },
                [`& > .${ErrorIconClass}`]: [{ margin: 0, display: 'none' }, props.theme.typography.helperText],
                [`&.${formLabelClasses.error} > .${ErrorIconClass}`]: {
                    display: 'block',
                },
            },
        ],
    },
};
